import React from 'react'

import TextField from '@mui/material/TextField';
import styled from 'styled-components'

const FormSectionRow = styled.div`
  display: flex;
  gap: 1vw;

  align-items: center;
`

export default function OrderRequisitionItem(props) {

  const [itemData, setItemData] = React.useState(props.itemData);

  const handleFieldInput = (e, fieldName) => {
    let newValue = e.target.value;
    setItemData(prevState => {
      let newItem = {... prevState, [fieldName]: newValue}
      props.syncParent(props.index, newItem)
      return newItem
    })
  }

  return (
    <FormSectionRow>
      <TextField
        label="Quantity"
        variant="outlined"
        onChange={e=>handleFieldInput(e, "quantity")}
      />
      <TextField
        label="Product/Service Name"
        variant="outlined"
        onChange={e=>handleFieldInput(e, "name")}
      />
      <TextField
        label="Description"
        variant="outlined"
        onChange={e=>handleFieldInput(e, "description")}
      />
      <TextField
        label="Unit Price"
        variant="outlined"
        onChange={e=>handleFieldInput(e, "unitPrice")}
      />
      <TextField
        label="Total Price"
        variant="outlined"
        onChange={e=>handleFieldInput(e, "totalPrice")}
      />
      <TextField
        label="Notes"
        variant="outlined"
        onChange={e=>handleFieldInput(e, "notes")}
      />
    </FormSectionRow>
  )
}
